export default "#pragma version 6\nint 1\nreturn";